/* eslint-disable @typescript-eslint/ban-ts-comment */
import * as React from 'react';
// @ts-ignore
import { FooterNotices } from './footerNotices';
import { CopyrightText } from './copyright-text';

export const Footer = () => {
    return (
        <>
            <div id="footer-container" className="footer-container">
                <div id="footer" className="footer">
                    <p id="footer-text-com">
                        You understand that you are providing information to Virtual Gaming Worlds. The information you
                        provide will only be used to administer this promotion.
                        <span style={{ color: '#FFFFFF', fontWeight: 'normal' }}>
                            &nbsp;NO PURCHASE NECESSARY to enter Sweepstakes. SWEEPSTAKES ARE VOID WHERE PROHIBITED BY
                            LAW
                        </span>
                        . For detailed rules, see
                        <a target="_blank" rel="noopener noreferrer" href="https://www.chumbacasino.com/sweeps-rules/">
                            {' '}
                            <em>Sweeps Rules</em>
                        </a>
                    </p>

                    <div id="MGA_footer">
                        <div
                            style={{
                                width: '100%',
                                margin: '40px 0 35px 0',
                                padding: '0',
                                textAlign: 'center',
                            }}
                        >
                            <ul style={{ margin: '0', padding: '0' }}>
                                <li>
                                    <a
                                        className="terms"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href="https://www.chumbacasino.com/terms-and-conditions-2/"
                                    >
                                        {' '}
                                        Terms &amp; Conditions
                                    </a>
                                </li>

                                <li>
                                    <a
                                        className="privacy-policy"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href="https://www.chumbacasino.com/privacy-policy/"
                                    >
                                        {' '}
                                        Privacy Policy
                                    </a>
                                </li>

                                <li>
                                    <a
                                        className="responsible-gaming"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href="https://www.chumbacasino.com/responsible-gaming/"
                                    >
                                        {' '}
                                        Responsible Social Gaming
                                    </a>
                                </li>

                                <li>
                                    <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href="https://chumbacasino.zendesk.com/hc/en-us/requests/new?ticket_form_id=41924"
                                    >
                                        {' '}
                                        Contact Us
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <FooterNotices />
                        <CopyrightText />
                    </div>
                </div>
            </div>
        </>
    );
};
